import { render, staticRenderFns } from "./addressDefault.vue?vue&type=template&id=4ee2bf8a&scoped=true&"
import script from "./addressDefault.vue?vue&type=script&lang=js&"
export * from "./addressDefault.vue?vue&type=script&lang=js&"
import style0 from "./addressDefault.vue?vue&type=style&index=0&id=4ee2bf8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee2bf8a",
  null
  
)

export default component.exports